import { Link as RouterLink } from 'react-router'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'
import PersonIcon from '@mui/icons-material/Person'
import { useDispatch } from 'react-redux'
import { setIsSidebarCollapsed } from '@/features/layout/layoutSlice'

export default function ProfileButton() {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  // const { data: user, isSuccess } = useGetDetailsQuery()

  // const initials =
  //   isSuccess && user?.first_name && user?.last_name
  //     ? `${user.first_name[0]}${user.last_name[0]}`
  //     : user?.username?.[0] || 'U'

  // const roleTitle =
  //   isSuccess && user?.roles?.[0]?.title ? user.roles[0].title : ''

  return (
    <Tooltip 
      title={ t('profile') }
      placement="top-start"  
    >
      <IconButton
        component={RouterLink}
        nativeButton={false}
        to="/profile"
        onClick={() => dispatch(setIsSidebarCollapsed(false))}
      >
        <PersonIcon />
        {/* <Avatar sx={{ width: 28, height: 28 }}>{initials}</Avatar> */}
      </IconButton>
    </Tooltip>
  )
  // return (
  //   <Box 
  //     sx={{ 
  //       display: 'flex', 
  //       alignItems: 'center', 
  //       gap: 1, 
  //       width: '100%' 
  //     }}
  //   >
  //     <IconButton size="small" onClick={onProfileClick}>
  //       <Avatar >{initials}</Avatar>
  //     </IconButton>
  //     <Box
  //       onClick={onProfileClick}
  //       sx={{ cursor: 'pointer', flex: 1, overflow: 'hidden' }}
  //     >
  //       <Typography variant="body2" noWrap>
  //         {user?.username || t('user')}
  //       </Typography>
  //       <Typography variant="caption" color="text.secondary" noWrap>
  //         {roleTitle}
  //       </Typography>
  //     </Box>

  //     <Fade in={!isCompact} timeout={400}>
  //       
  //     </Fade>
  //   </Box>
  // )
}
